export type ProfileViewerCapability =
  'self' | 'team_manager' | 'organisation_admin' | 'super_admin';

export function profileViewTabs(viewerCapability: ProfileViewerCapability): string[] {
  const tabs = ['profile'];
  if (viewerCapability !== 'self') tabs.push('access');
  if (viewerCapability === 'organisation_admin' || viewerCapability === 'super_admin') {
    tabs.push('security');
  }
  if (viewerCapability === 'super_admin') tabs.push('platform');
  return tabs;
}
